(function (window, document, $) {

    $(document).ready(function () {

        // load latest and favorite video list ===============================================================
        if ($('[data-load-latest-videos]').length || $('[data-load-favorite-videos]').length) {
            $.ajax({
                url: themevars.ajaxurl,
                data: {
                    action: 'get_favorites_videos',
                },
                type: 'POST',
                dataType: 'json'
            }).done(function (result) {
                $('.loading-container').remove();

                // if not logged_in show not logged in text
                if($('[data-load-favorite-videos]').length && !result.data.logged_in) {
                    $('[data-load-favorite-videos-notloggedin]').addClass('d-block');
                    $('[data-load-favorite-videos-target]').addClass('d-none');
                }

                if(result.data.logged_in) {
                    // if the user has no favorite video's yet, show the no video's text
                    if (undefined === result.data.favorite_videos || result.data.no_favorite_videos_found) {
                        $('[data-load-favorite-videos-noresults]').addClass('d-block');
                        $('[data-load-favorite-videos-target]').addClass('d-none');
                    } else {  
                        // add the video's to the target element                      
                        $('[data-load-favorite-videos-target]').append(result.data.favorite_videos);
                        $(document).trigger('wpgu-set-favorites-selected');
                    }
                }

                if (true !== result.success) {
                    return;
                }
            });
        }
    });

}(window, document, jQuery));
